import { Injectable } from '@angular/core';
import { HttpParams } from '@angular/common/http';
import { Observable } from 'rxjs';


import { ConfigServerService, CustomHttp } from '../../../core';
import { UnidadeNegocio } from '../../unidade-negocio';

@Injectable({
    providedIn: 'root'
})
export class UsuarioUnidadeNegocioHttpService {
    private pathApi: string;

    constructor(configServerService: ConfigServerService,
                private customHttp: CustomHttp) {
        this.pathApi = `${configServerService.getPathApi()}/usuario`
    }

    /** Cria os paramêtros para a pesquisa das unidades de negócios dos usuários */
    private createParams(situacoesUnidadesNegocios: number[], situacoesLinhasProducoes: number[]) {
        // Params
        let params = new HttpParams();
        // Situações das unidades de negócios
        if (situacoesUnidadesNegocios?.length > 0) {
            situacoesUnidadesNegocios.forEach(situacaoUnidadeNegocio => {
                params = params.append('situacaoUnidadeNegocio', situacaoUnidadeNegocio.toString());
            });
        }
        // Situações das classificações
        if (situacoesLinhasProducoes?.length > 0) {
            situacoesLinhasProducoes.forEach(situacaoLinhaProducao => {
                params = params.append('situacaoLinhaProducao', situacaoLinhaProducao.toString());
            });
        }

        return params;
    }

    /** Pesquisa as unidades de negócios para o usuário informado */
    searchUnidadesNegocios(idUsuario: number, situacoesUnidadesNegocios: number[] = null, situacoesClassificacoes: number[] = null): Observable<UnidadeNegocio[]> {
        const params = this.createParams(situacoesUnidadesNegocios, situacoesClassificacoes);
        return this.customHttp.get<UnidadeNegocio[]>(`${this.pathApi}/${idUsuario}/unidadenegocio`, {params});
    }

    /** Pesquisa unidades de negócios cadastradas para o usuário logado */
    searchUnidadesNegociosUsuarioLogado(situacoesUnidadesNegocios: number[] = null, situacoesLinhasProducoes: number[] = null): Observable<UnidadeNegocio[]> {
        const params = this.createParams(situacoesUnidadesNegocios, situacoesLinhasProducoes);
        return this.customHttp.get<UnidadeNegocio[]>(`${this.pathApi}/0/unidadenegocio`,  {params});
    }
}
